<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M512 512z" :fill="_fill" />
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M512 72c-113.4 0-206 92.6-206 206v195.3c0 113.4 92.6 206 206 206l5-.1c111.5-2.9 201-94.6 201-205.9V278c0-113.4-92.6-206-206-206zm0 62.8c78.7 0 143.1 64.5 143.1 143.2v195.3c0 77.3-62.3 141.1-139.4 143.1h-4.1c-78.2 0-142.7-64.5-142.7-143.1V278c-.1-78.7 64.4-143.2 143.1-143.2zm0 0" />
        <path d="M826.2 460c8.3 0 16.3 3.3 22.2 9.2 5.9 5.9 9.2 13.9 9.2 22.2 0 181.1-155.9 328.4-345.7 328.4-189.8 0-345.7-147.3-345.7-328.4 0-17.4 14.1-31.4 31.4-31.4 17.4 0 31.4 14.1 31.4 31.4C229.2 637 356.1 757 512 757s282.8-120 282.8-265.6c0-17.3 14.1-31.4 31.4-31.4zm0 0" />
        <path d="M512 757c16.4 0 30.1 12.7 31.3 29.1l.1 2.4v132c.1 16.9-13.3 30.9-30.3 31.5-16.9.6-31.3-12.3-32.5-29.2l-.1-2.4v-132c.1-17.3 14.1-31.4 31.5-31.4zm-62.8-478.8c16.4 0 30.1 12.7 31.3 29.1l.1 2.4v132c.1 16.9-13.3 30.9-30.3 31.5-16.9.6-31.3-12.3-32.5-29.2l-.1-2.4v-132c0-17.4 14.1-31.4 31.5-31.4zm0 0" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
